import React from 'react'
import MaskedInput from 'react-text-mask'
function InputCNPJ({ value, onChange }) {

    const mask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];

    return (
        <MaskedInput inputMode='numeric' mask={mask} placeholder='CNPJ' className="form-control" value={value} onChange={value => {
            onChange(value.target.value)
        }}></MaskedInput>)
}

export default InputCNPJ